import { Component, OnInit, Input,OnChanges, SimpleChanges  } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TarifaService } from 'src/app/services/convenio/tarifa.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { CarrilService } from 'src/app/services/carril.service';
@Component({
  selector: 'app-tarifa-por-carril',
  templateUrl: './tarifa-por-carril.component.html',
  styleUrls: ['./tarifa-por-carril.component.scss']
})
export class TarifaPorCarrilComponent implements OnChanges {

  dataFormTarifas = [];
  user: any;
  nombre: string="";
  validator = false
  public temp: any
  public rowsT: any
  dataCatTarifas: any
  confirmModal = false
  changTarifa: any
  @Input() dataTarifas: any;
  @Input() aplicarTarifasPorCarril:any

  jsonChangTarifa: any=null;
  nuevaTarifaPorCarrilany:any[]=[]
  carriles: any

  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private tarifaService: TarifaService,
  ) {

  }
  nuevaTarifaPorCarril: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.store.select(selectUser).subscribe(user => this.user = user);

    this.tarifaService.getCarriles().subscribe((carriles: any) => {this.carriles = carriles; })
    if (changes['dataTarifas'] && this.dataTarifas?.length) {
      this.nuevaTarifaPorCarril.push({
        tarifas: this.dataTarifas.reduce((acc, t) => {
          acc[t.id] = 0;
          return acc;
        }, {}),
        carriles: []
      });
    }
  }


  getNombreTarifa(event:any) {
    this.nombre = event.target.value
  }
  agregarTarifas() {

      this.nuevaTarifaPorCarril.push({
        tarifas: this.dataTarifas.reduce((acc, t) => {
          acc[t.id] = 0;
          return acc;
        }, {}),
        carriles: []
      });
  }
  actualizarJsonNuevaTarifa(indice: number, campo: string,id_tarifa: number=0, event: any) {
    if (campo === 'carril') {
      this.nuevaTarifaPorCarril[indice].carriles = event.target.selectedOptions.length > 0 ? Array.from(event.target.selectedOptions).map((opt: any) => opt.value) : [];
    }
    if (campo === 'tarifa') {
      this.nuevaTarifaPorCarril[indice].tarifas[id_tarifa] = Number(event.target.value);
    }
  }
  saveTarifas() {
    let data = {
      tarifas: this.nuevaTarifaPorCarril,
      id_usuario: this.user.id,
      nombre: this.nombre
    }
    console.log(data);
    this.ngxUiLoaderService.start();
    //api
    this.tarifaService.saveTarifa(data)
      .subscribe(tarifa => {
        this.finished('Tarifas')
        this.tarifaService.getTarifasResource().subscribe(data => {this.dataTarifas=data});

        this.ngxUiLoaderService.stop();
      }), error => {
        this.toastr.error(`Ocurrio un problema`, error, { positionClass: 'toast-bottom-right' });
      }
    this.ngxUiLoaderService.stop();


    var nombreTarifa = document.getElementsByClassName("tarifaNombre");
    const nombre = nombreTarifa[0]as HTMLInputElement;
    nombre.value = "";
    var inputTarifas = document.getElementsByClassName("tarifasEntries");
    for(let tar = 0 ;tar < inputTarifas.length; tar++){
      const element = inputTarifas[tar]as  HTMLInputElement;
          element.value="0";
    }
  }
  finished(type: string) {
    //setear variables
    this.dataFormTarifas = []
    this.nombre = "";
    this.validator = false;
    this.dataFormTarifas = []
    this.toastr.success(`${type} guardado con éxito`, '', { positionClass: 'toast-bottom-right' });

    //this.router.navigate(['/dashboard/convenio']);
  }
}
